import store from "@/store";

export const handleAuthFlush = () => {
  store.dispatch("auth/flushAuth");
};
